var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/Trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5268 7.80467L8.96341 9.33333L10.5268 10.862C10.7934 11.1227 10.7934 11.544 10.5268 11.8047C10.3939 11.9347 10.2193 12 10.0448 12C9.87023 12 9.69568 11.9347 9.56273 11.8047L7.99932 10.276L6.43591 11.8047C6.30295 11.9347 6.12841 12 5.95386 12C5.77932 12 5.60477 11.9347 5.47182 11.8047C5.20523 11.544 5.20523 11.1227 5.47182 10.862L7.03523 9.33333L5.47182 7.80467C5.20523 7.544 5.20523 7.12267 5.47182 6.862C5.73841 6.60133 6.16932 6.60133 6.43591 6.862L7.99932 8.39067L9.56273 6.862C9.82932 6.60133 10.2602 6.60133 10.5268 6.862C10.7934 7.12267 10.7934 7.544 10.5268 7.80467ZM15.4993 3.33333C15.4993 3.702 15.1939 4 14.8175 4H14.2141L13.3441 12.9813C13.177 14.702 11.718 16 9.95 16H6.04523C4.28 16 2.82091 14.7047 2.65182 12.986L1.76818 4H1.18182C0.805454 4 0.5 3.702 0.5 3.33333C0.5 2.96467 0.805454 2.66667 1.18182 2.66667H3.97795C4.295 1.14733 5.67227 0 7.31818 0H8.68182C10.3277 0 11.7057 1.14733 12.022 2.66667H14.8182C15.1945 2.66667 15.4993 2.96467 15.4993 3.33333ZM5.38932 2.66667H10.6093C10.3277 1.89067 9.57023 1.33333 8.68114 1.33333H7.3175C6.42841 1.33333 5.67091 1.89067 5.38932 2.66667ZM12.8443 4H3.13795L4.00932 12.858C4.11023 13.8893 4.98568 14.6667 6.04523 14.6667H9.95C11.0109 14.6667 11.8864 13.888 11.9866 12.8547L12.8443 4Z",
    fill: "#F44336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.7fac366b8b0ec3653d12c19e61f08bf0.svg";
export { ForwardRef as ReactComponent };